module.exports = __webpack_public_path__ + "Ellipse_1.ade99b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/RegisterUser/images/Ellipse_1.png
// module id = 15mg
// module chunks = 0